import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 查询作业计划完成回传素材
 * @param {Object} data 参数
 * @returns
 */
export function getWorkdayTaskAttach (data) {
  return request.post('/ooh-msp/v3/apptask/getWorkdayTaskAttach', qs.stringify(data))
}
